import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "@/components/motion";
import { IMAGES } from "@/data/site";

export default function Intro() {
  return (
    <section className="relative overflow-hidden bg-white py-28 lg:py-36" data-testid="intro-section">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Chapter index="01" label="Who We Are" />
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl">
                A Workforce Partner<br />You Can <span className="text-gold">Rely On</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 font-heading text-xl font-bold leading-snug text-charcoal">
                Construction projects depend on people.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:pt-24">
            <Reveal delay={0.15}>
              <p className="text-base leading-relaxed text-charcoal/75">
                At Formcore Constructions, we understand that having the right personnel available at the right time
                can directly influence productivity, project delivery and client outcomes. We provide professionally
                managed labour hire solutions designed around the operational requirements of our clients.
              </p>
              <p className="mt-5 text-base leading-relaxed text-charcoal/75">
                Our workforce is carefully selected, continuously developed and supported by an experienced management
                team with extensive knowledge of construction operations, workforce management, safety, compliance and
                financial administration.
              </p>
              <p className="mt-5 text-base leading-relaxed text-charcoal/75">
                Whether you require additional personnel for an immediate project requirement or a workforce partner
                capable of supporting an ongoing operation, Formcore delivers a responsive and professional solution.
              </p>
              <Link
                to="/about"
                data-testid="intro-about-link"
                className="mt-8 inline-flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-[0.15em] text-navy transition-colors hover:text-gold"
              >
                About Formcore
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Reveal>
          </div>
        </div>

        <div className="relative mt-24">
          <div className="absolute -bottom-5 -right-5 hidden h-full w-full border-2 border-gold md:block" />
          <Reveal>
            <img
              src={IMAGES.intro}
              alt="Formcore supervisors and workforce coordinating on site"
              className="clip-frame relative h-[300px] w-full object-cover md:h-[460px]"
            />
          </Reveal>
          <Reveal delay={0.2} className="relative z-10 -mt-16 ml-6 max-w-sm border border-navy/10 bg-white p-6 md:ml-12">
            <p className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-navy">
              Management experience across Tier 1 & major construction environments
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
